import { Outlet, useLocation } from 'react-router-dom'
import { DashboardContainer } from '../Dashboard'
import { SideNav } from './SideNav'

const Settings = () => {
   const location = useLocation()
   const isStageMapping = location.pathname.includes('stage-mapping')

   return (
      <>
         <DashboardContainer>
            <div className="flex gap-5 mt-5">
               <div className={`flex flex-1 gap-5 overflow-hidden bg-primary/10 rounded-xl max-h-[calc(100vh-110px)] min-h-[calc(100vh-110px)] overflow-y-auto ${isStageMapping ? '' : 'max-w-[1100px]'}`}>
                  <SideNav />
                  <Outlet />
               </div>
            </div>
         </DashboardContainer>
      </>
   )
}

export default Settings
